import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/common/header/header";
import Product from "./components/pages/product/product";
import Footer from "./components/common/footer/footer";
import About from "./components/pages/about/about";
import Home from "./components/pages/home/home";
import ProductList from "./components/pages/product list/productList";
import ProductDetails from "./components/pages/product details/productDetails";
import Contact from "./components/pages/contact/contact";
import Gallary from "./components/pages/gallary/gallary";
import Loader from "./components/common/loader/loader";
import Inquiry from "./components/common/inquiry/inquiry";
import Whatsapp from "./components/common/whatsapp/whatsapp";
import ScrollToTop from "./components/ScrollToTop"

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="page-wraper">
     
      {loading ? (
        <Loader />
      ) : (
        <Router>
         
          <Header /> {/* Render the Header component outside of the Routes */}
          <Inquiry/>
          {/* <Whatsapp/> */}
          <div className="page-content">
            <Routes>
         
            <Route exact path="/" element={<Home />} />
            <Route exact path="/product" element={<Product />} />
            <Route exact path="/products.html" element={<Product />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/home" element={<Home />} />
          
            <Route exact path="/product/:id" element={<ProductList />} />
          
            <Route exact path="/products/:id" element={<ProductDetails />} />
            <Route exact path="/productDetails" element={<ProductDetails />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route exact path="/contact-us.html" element={<Contact />} />
            <Route exact path="/gallary" element={<Gallary />} />
            </Routes>
          </div>
          <Footer />
        </Router>
      )}
    </div>
  );
}

export default App;
